const hoverEffect = {
    data() {
        return {
            hover: false,
            elementKey: null,
        };
    },
    methods: {
        onSelected(color) {
            return {
                boxShadow: `0 0 0 3px ${color}`,
            };
        },
        hoverAnimation(color, key) {
            if (key === this.elementKey) {
                return {
                    boxShadow: `0 0 0 3px ${color}`,
                    transition: 'all .2s',
                };
            }
        },
        onMouseOver(key) {
            this.hover = true;

            this.elementKey = key;
        },
        onMouseLeave() {
            this.hover = false;

            this.elementKey = null;
        },
    },
};

export default hoverEffect;
